import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="mx-auto text-muted-foreground mb-4" size={48} />
      <h1 className="font-serif text-3xl text-navy">Payment Cancelled</h1>
      <p className="text-muted-foreground mt-2">No worries — your cart is still saved. You can try again anytime.</p>
      <div className="flex gap-3 justify-center mt-7">
        <Link to="/checkout" className="bg-gold text-navy font-semibold px-6 py-3 rounded-full hover:bg-gold-light transition-colors">Try Again</Link>
        <Link to="/cart" className="border border-navy/25 text-navy font-semibold px-6 py-3 rounded-full">Back to Cart</Link>
      </div>
    </div>
  );
}
